import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Tooltip } from 'components/core/Tooltip';

import './TooltipBanner.scss';

export function TooltipBanner({
    tooltipContent,
    triggerId,
    visible,
    onShowTooltip,
    onHideTooltip,
    tooltipIcon,
    last,
    className,
}) {
    return (
        <div className="tooltip-icon">
            <Tooltip
                className={classnames('tooltip-banner', className, { last })}
                triggerId={triggerId}
                content={<div className="tooltip-banner__content">{tooltipContent}</div>}
                visible={visible}
                onShowTooltip={onShowTooltip}
                onHideTooltip={onHideTooltip}
            >
                {tooltipIcon}
            </Tooltip>
        </div>
    );
}

TooltipBanner.propTypes = {
    tooltipContent: PropTypes.string,
    triggerId: PropTypes.string.isRequired,
    tooltipIcon: PropTypes.element,
    visible: PropTypes.bool,
    onShowTooltip: PropTypes.func,
    onHideTooltip: PropTypes.func,	
    last: PropTypes.bool,
    className: PropTypes.string,
};

export default TooltipBanner;
